export default __webpack_public_path__ + "static/media/cancel.ff14c4cc.svg";